module.exports = __webpack_public_path__ + "img/achievement3.ceb92f49.png";